<script>
    import TableList from './TableList.svelte';

    let tableData = {
        details: { 
            titleList: 'User Details' ,
            titleEdit: 'User Record' ,
            create: true,
            delete: true,
            edit: true,
            hasMediaFile: false,
            mediaFileType: 'image/*',            
            sortby: 'last_name',
        },
        fields: [
            { 
                key: 'email', 
                label: 'Email', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'salutation', 
                label: 'Salutation', 
                type: 'text',
                editable: true, 
                sortable: true 
            },
            { 
                key: 'first_name', 
                label: 'First Name', 
                type: 'text',
                editable: true, 
                sortable: true 
            },
            { 
                key: 'last_name', 
                label: 'Last Name', 
                type: 'text',
                editable: true, 
                sortable: true 
            },
            { 
                key: 'phone', 
                label: 'Phone', 
                type: 'text',
                editable: true, 
                sortable: true 
            },
            { 
                key: 'credit_total', 
                label: 'Tokens', 
                type: 'text',
                editable: false, 
                sortable: true 
            },
            { 
                key: 'user_role.name', 
                value: 'user_role.uuid', 
                model_key: 'user_role_uuid', 
                label: 'User Role', 
                type: 'select',
                editable: true,
                sortable: true,
                select: { 
                    data_list: 'user_roles',
                    key: 'uuid',
                    display: 'name', 
                    search_key: 'user_role_uuid',
                    searchable: true
                }
            },
            { 
                key: 'user_status.name', 
                value: 'user_status.uuid', 
                model_key: 'user_status_uuid', 
                label: 'User Status', 
                type: 'select',
                editable: true,
                sortable: true,
                select: { 
                    data_list: 'user_statuses',
                    key: 'uuid',
                    display: 'name', 
                    search_key: 'user_status_uuid',
                    searchable: true
                }
            }
        ]
    };

</script>

<TableList modelName="user" {tableData} />
